// extracted by mini-css-extract-plugin
export default {"statConn":"Doughnut_statConn__15scA","containerConn":"Doughnut_containerConn__xBfwN"};